import React, { Component } from 'react';
import App from "../../App";
import {FaLongArrowAltLeft, FaPrint } from "react-icons/all";
import "../../assets/scss/invoice.scss";
import { withRouter, Link } from "react-router-dom";
import ReactToPrint from "react-to-print";
import QRCode from "qrcode.react";
import { toast } from "react-toastify";
import { Button, Form } from "react-bootstrap";
import { getData, getList, putData } from "../../services/baseServices";
import { getDetails } from "../../services/baseServices";
import { twoDecimalPlace, getFormattedDate, getDate, humanize } from "../../helper/utils";
import _ from 'lodash'
import moment from 'moment';

const default_state = {
  isLoading: true,
  status: null,
  changingStoreId: null,
  changeStatusMsg: '',
  isShowingStatusChangeConfirmModal: false,
  isSubmitting: false,
  packedStatus: false,
  isFormValidated: false,
  pickUpPointOrder: false,
  ridersList: [],
  colspan: 4,
  printcolspan: 2,
  invoiceShow: false,
  readyToShip: false,
  cancelled: false,
  orderDetail: {},
  riderId: null,
  qrCodes: [],
  packedOrders: [{line_item_id: '', qr_codes: []}],
  qrCodeMatching: [],
  packedBtn: false,
  StatusMsgRequired: false,
  orderLocations: {},
  routeDetails: {},
  schedule: [],
  orderToBeUnpacked: false,
  packedCancelled: false,
  variants_locations: [],
}

class OrderDetails extends Component {
  state = default_state

  componentDidMount() {
    this.loadData()
  }

  loadData = () => {
    this.setState(default_state)
    getData("customer_orders/"+ this.props.match.params.id)
      .then(res => {
        this.setState({orderDetail: res?.data, isLoading: false})
        
        if(res?.data?.rider?.id) {
          this.setState({riderId: res?.data?.rider?.id})
        }
        if (res?.data?.status_key === 'ready_to_shipment') {
          this.setState({readyToShip: true});
        }
        // if (res.status_key === 'cancelled') {
        //   this.setState({cancelled: true});
        // }
        // if (res.status_key == 'packed_cancelled') {
        //   this.setState({packedCancelled: true});
        // }
        if (res?.data?.partner.schedule) {
          this.setState({schedule: res?.data?.partner.schedule.toUpperCase().split("_")})
        }
        if (res?.data?.shipping_type !== 'Pick up point') {
          getList('riders')
            .then(res => {
              this.setState({pickUpPointOrder: true});
              this.setState({
                ridersList: res,
                isLoading: false,
              }, () => {
              });
            })
            .catch(errMsg => {
            })
        } else {
          getDetails("routes", res?.data?.partner.route_id)
            .then(res=> {
              this.setState({routeDetails: {...res?.data}})
            })
            .catch(errMsg => {
              console.log(errMsg)
            })
        }
      })
      .catch(errMsg => {
        console.log('Err Msg: ', errMsg)
      });
  }

  assignRider = e => {
    const params = {
      rider_id: e.target.value
    }
    putData(`customer_orders/${this.props.match.params.id}/assign_rider`, params)
      .then(res => {
        if(res?.success) {
          toast.success(res?.message);
          this.loadData()
        } else {
          toast.error(res?.message);
        }
      })
      .catch(errMsg => {
        toast.error(errMsg);
      })
  }

  selectRider = e => {
    this.setState({riderId: e.target.value});
  }

  render() {
    const {orderDetail} = this.state
    const {routeDetails} = this.state

    return (
      <App layout="">
        <div className="main-content">
          <div className="page-header">
            <h2 className="page-title">Order Details</h2>
            <div className="ml-auto">
              <Link onClick={()=> this.props.history.go(-1)}
                    className="btn btn-sm btn-link"><FaLongArrowAltLeft/> Back to Previous Page</Link>
            </div>
          </div>
          {this.state.isLoading ?
            <div className={`card-block`}>
              <div className="block-body">
                Loading...
              </div>
            </div>
            :
            <div className="card-block">
              <>
                <Form
                  noValidate
                  validated={this.state.isFormValidated}
                  onSubmit={!this.state.orderToBeUnpacked ? this.handleWithDebouncePackSubmit : this.handleWithDebounceUnpackSubmit}>
                  <div className="block-header text-right">
                    {!this.state.packedStatus && !this.state.orderToBeUnpacked && <div>
                      <ReactToPrint
                        trigger={() => {
                          return (<a href="#">
                            <Button variant={"default"} onClick={this.handlePrint} size={"sm"}><FaPrint/> Print Invoice
                            </Button>
                          </a>)
                        }}
                        content={() => this.componentRef}
                      />
                    </div>}

                  </div>
                  {(this.state.readyToShip && orderDetail?.shipping_type !== "Pick up point") &&
                    <div className="block-body">
                      <td>
                        <div><b>Assign Rider</b></div>
                        <select id="rider"
                                name="rider"
                                value={this.state.riderId}
                                className='form-control form-control-sm'
                                required
                                onChange={(e) => this.assignRider(e)}>
                          <option value="">--Select Rider--</option>
                          {this.state.ridersList && this.state.ridersList?.map((ride, index) => {
                            return (<option value={ride?.id}>{ride?.name}</option>)
                          })}
                        </select>
                      </td>
                    </div>
                  }
                  <div className="block-body print-outer" ref={el => (this.componentRef = el)}>
                    <div className="only-print">
                      <br/>
                      <br/>
                      <br/>
                      <br/>
                      <QRCode value={`${orderDetail?.order_id}`}/>
                      <br/>
                    </div>

                    <table className="invoice-table">
                      <tbody>

                      <tr className="v-top">
                        <td>
                          <h3 className="invoice-title">Order # 0000{orderDetail?.order_id}</h3>
                          <span
                              className="d-block"><strong>Central BIN</strong> : {getDate(orderDetail?.order_at)>=moment('2021-09-19')?'003279334-0101': '003279334-0203'}</span>
                          <span
                              className="d-block"><strong>Order Status</strong> : {humanize(orderDetail?.status)}</span>
                          <span
                              className="d-block"><strong>Shipping Type</strong> : {orderDetail?.shipping_type}</span>
                              <span
                              className="d-block"><strong>Distributor</strong> : {orderDetail?.distributor_name}</span>
                          <span className="d-block"><strong>Order Date</strong> : {getFormattedDate(orderDetail?.order_at, 'LT, ll')}
                            </span>
                            <span className={`d-block ${orderDetail?.preferred_delivery_date?'': 'mb-2'}`}><strong>Order Deadline</strong> : {orderDetail?.shipping_type === "Express delivery" ?
                                      getDate(orderDetail?.order_at).add(3, 'hours').format('LT, ll')
                                      :getDate(orderDetail?.order_at).add(72, 'hours').format('LT, ll')
                                    }
                            </span>

                              {
                                orderDetail?.preferred_delivery_date && (
                                  <span className="d-block mb-2"><strong>Preferred Delivery Date</strong> : { getFormattedDate(orderDetail?.preferred_delivery_date, 'LT, ll')}</span>
                                )
                              }
                        </td>
                        <td className="text-right">
                          <span className="d-block"><h6>Customer Information</h6></span>
                          <span className="d-block">{orderDetail?.customer?.name}</span>
                          <span className="d-block">{orderDetail?.customer?.email}</span>
                          <span className="d-block">{orderDetail?.customer?.phone}</span>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan="2">
                        </td>
                      </tr>

                      <tr>
                        <td colSpan="2">
                          <table>
                            <tbody>
                            <tr>
                              {/* <td style={{paddingBottom: '20px'}}>
                                <h4 className="invoice-title-alt">Shipping Type</h4>
                                <span className="d-block">{orderDetail?.shipping_type}</span>
                              </td> */}
                              {(orderDetail?.shipping_type === "Home delivery" || orderDetail?.shipping_type === "Express delivery") &&
                                <>
                                  <td style={{paddingBottom: '20px'}}>
                                    <h4 className="invoice-title-alt">Shipping Address</h4>
                                    <span className="d-block">{orderDetail?.shipping_address?.address_line}</span>
                                    <span className="d-block">{orderDetail?.shipping_address?.area}</span>
                                    <span className="d-block">{orderDetail?.shipping_address?.thana}</span>
                                    <span className="d-block">{orderDetail?.shipping_address?.district}</span>
                                    <span className="d-block">{orderDetail?.shipping_address?.phone}</span>
                                  </td>

                                  {/* <td style={{paddingBottom: '20px'}}>
                                    <h4 className="invoice-title-alt">Billing Address</h4>
                                    <span className="d-block">{orderDetail?.billing_address?.address_line}</span>
                                    <span className="d-block">{orderDetail?.billing_address?.area}</span>
                                    <span className="d-block">{orderDetail?.billing_address?.thana}</span>
                                    <span className="d-block">{orderDetail?.billing_address?.district}</span>
                                    <span className="d-block">{orderDetail?.billing_address?.phone}</span>
                                  </td> */}

                                  {orderDetail?.rider?.name &&
                                  <td style={{paddingBottom: '20px'}}>
                                    <h4 className="invoice-title-alt">Rider Info</h4>
                                    <span className="d-block">{orderDetail?.rider?.name}</span>
                                    <span className="d-block">{orderDetail?.rider?.phone}</span>
                                  </td>}
                                </>
                              }
                              {orderDetail?.shipping_type === "Pick up point" && Object.keys(orderDetail?.partner)?.length > 0 &&
                                <td style={{paddingBottom: '20px'}}>
                                  <h4 className="invoice-title-alt">Pick-up Point</h4>
                                  <span className="d-block">{orderDetail?.partner?.name}</span>
                                  <span className="d-block">{orderDetail?.partner?.phone}</span>
                                  <span className="d-block">{orderDetail?.partner?.email}</span>
                                  <span className="d-block">{orderDetail?.partner?.area}</span>
                                  <span className="d-block">{this.state.schedule &&
                                    this.state.schedule.map((item, index, array) => (
                                      index < array.length-1 ?
                                        <><span className='text'>{item}</span>, </>
                                        : <> & <span className='text'>{item}</span> </>
                                    ))
                                  }</span>
                                  <span className="d-block">Route Name : {routeDetails?.title}</span>
                                  <span className="d-block">Section : {orderDetail?.partner?.section}</span>
                                  {/* <span className="d-block">Distributor : {_.capitalize(orderDetail?.partner?.distributor_name)}</span> */}
                                </td>
                              }
                              {!_.isEmpty(orderDetail?.receiver_info) &&
                              <td style={{paddingBottom: '20px'}}>
                                <h4 className="invoice-title-alt">Receiver Info</h4>
                                <span className="d-block">{orderDetail?.receiver_info?.name}</span>
                                <span className="d-block">{orderDetail?.receiver_info?.phone}</span>
                              </td>
                              }
                              <td style={{paddingBottom: '20px'}}>
                                <h4 className="invoice-title-alt">Payment</h4>
                                <span className="d-block">Type: {orderDetail.pay_type}</span>
                                <span className="d-block">Status: {orderDetail.is_customer_paid?"Paid":"Pending"}</span>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan={2}>
                          <table className="table table-bordered">
                            <thead>
                            <tr>
                              <th>Item</th>
                              <th className={'text-center'}>Unit Price</th>
                              <th className={'text-center'}>Quantity</th>
                              <th className={'text-center'}>Discount</th>
                              {this.state.packedStatus && <th style={{width: '200px'}}>QR Code</th>}
                              {(this.state.packedStatus || this.state.orderToBeUnpacked) && <th style={{width: '200px'}}>Select Location</th>}
                              <th className="text-right">Amount (৳)</th>
                            </tr>
                            </thead>

                            <tbody>

                            {orderDetail?.shopoth_line_items && orderDetail?.shopoth_line_items.length > 0 ?
                              orderDetail?.shopoth_line_items?.map((item, index) => (
                                <React.Fragment key={index}>
                                  <tr key={index + 1}>
                                    <td width={400}>
                                      <span className="d-block"><strong>{item.item?.product_title}</strong></span>
                                      <span className="d-block text-muted">
                                  {item.item.product_attribute_values.map((value, index) => {
                                      return (
                                        <>
                                          {value.value}{item.item.product_attribute_values.length > index + 1 ? '-' : ''}
                                        </>

                                      )
                                    }
                                  )}
                                    </span>
                                </td>
                                <td className={`text-center`}>{twoDecimalPlace(item.item.unit_price)}</td>
                                <td className={`text-center`}>{item.quantity}</td>
                                <td className={`text-center`}>{twoDecimalPlace(item.item.product_discount)}</td>

                                
                                <td className="text-right">{twoDecimalPlace(item?.sub_total)}</td>
                              </tr>
                            </React.Fragment>
                          ))
                          :
                          ''
                        }
                        <tr className="text-bold">
                          <td colSpan={this.state.colspan} className="text-right">Sub-Total (inclusive of VAT @ 5% *)</td>
                          <td className="text-right">{twoDecimalPlace(orderDetail?.sub_total)}</td>
                        </tr>

                        <tr className="text-bold">
                          <td colSpan={this.state.colspan} className="text-right">Discount</td>
                          <td className="text-right">{twoDecimalPlace(orderDetail?.total_discount_amount)}</td>
                        </tr>

                        <tr className="text-bold">
                          <td colSpan={this.state.colspan} className="text-right">Shipping Charge</td>
                          <td className="text-right">{twoDecimalPlace(orderDetail?.shipping_charge)}</td>
                        </tr>
                        <tr className="text-bold">
                          <td colSpan={this.state.colspan} className="text-right">VAT@ 15% on Shipping Charge</td>
                          <td className="text-right">{twoDecimalPlace(orderDetail?.vat_shipping_charge)}</td>
                        </tr>

                        <tr className="text-bold">
                          <td colSpan={this.state.colspan} className="text-right">Grand Total</td>
                          <td className="text-right">{twoDecimalPlace(orderDetail?.grand_total)}</td>
                        </tr>

                        </tbody>
                      </table>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <h6> <i>*VAT @ 5% is on the differential between Sales & Purchase price</i></h6>

              </div>
                </Form>
              </>
            </div>
          }
        </div>
      </App>
    );
  }
}

export default withRouter(OrderDetails);
